import React from 'react';

import MetricBox from './MetricBox';

interface GpsStatusProps {
  reception: string;
  fixState: string;
}

const GpsStatusIndicator: React.FC<GpsStatusProps> = ({ reception, fixState }) => (
  <div className='flex space-x-2'>
    <MetricBox label='GPS' value={reception} />
    <MetricBox label='Fix' value={fixState} />
  </div>
);

export default GpsStatusIndicator;
